import { useEffect, useState } from "react";
import { fetchAdvanceApprovalData, sendAdvanceApprovalRequest } from "../Api/AdvanceRequestApproval";
import { Container, Table, Button, ButtonGroup } from "react-bootstrap";
import { toast } from "react-toastify";
//import "./../Styling/AdvanceRequestApproval.css";

const AdvanceRequestApproval = () => {
  const [approvals, setApprovals] = useState([]);

  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const response = await fetchAdvanceApprovalData();
        const responseData = Array.isArray(response) ? response : (response.data || []);
        
        const transformedData = responseData.map(item => ({
          advanceReq_id: item.advanceReqId || item.advanceReq_id || item.id,
          purposeOfAdvance: item.purposeOfAdvance,
          destination: item.destination,
          dateOfTravel: item.datesOfTravel || item.dateOfTravel,
          advanceAmountRequested: item.advanceAmountRequested,
          dateOfRequest: item.dateOfRequest,
          approvalAuthority: item.approvalAuthority,
          modeOfAdvanceDisbursement: item.modeOfAdvanceDisbursement,
          approvalStatus: item.approvalStatus || "Pending", // Default to "Pending"
          createdBy: item.createdBy
        }));
        
        setApprovals(transformedData);
      } catch (error) {
        toast.error("Error Fetching Advance Approval Data");
        console.error("Error details:", error);
      }
    };
    loadApprovals();
  }, []);

  const handleStatusUpdate = async (advanceReqId, status) => {
    try {
      const userId = localStorage.getItem("userId") || "5";
      await sendAdvanceApprovalRequest(advanceReqId, status, userId);
      
      const action = status === "Approved" ? "Approved" : "Rejected";
      toast.success(`Advance Request ${advanceReqId} ${action}!`);
      
      setApprovals(prevApprovals => 
        prevApprovals.map(item => 
          item.advanceReq_id === advanceReqId 
            ? { ...item, approvalStatus: status } 
            : item
        )
      );
    } catch (error) {
      toast.error(`Error ${status === "Approved" ? "Approving" : "Rejecting"} Advance Request`);
      console.error("Error:", error);
    }
  };

  const getStatusClass = (status) => {
    switch(status) {
      case "Pending": return "status-waiting";
      case "Approved": return "status-approved";
      case "Rejected": return "status-rejected";
      default: return "";
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">Advance Request Approval</span>

          {approvals.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Advance Request Id</th>
                      <th>Purpose Of Advance</th>
                      <th>Destination</th>
                      <th>Date of Travel</th>
                      <th>Advance Amount</th>
                      <th>Date of Request</th>
                      <th>Approval Authority</th>
                      <th>Mode of Disbursement</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvals.map((approval, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{approval.advanceReq_id}</td>
                        <td>{approval.purposeOfAdvance}</td>
                        <td>{approval.destination}</td>
                        <td>{new Date(approval.dateOfTravel).toLocaleDateString()}</td>
                        <td>{approval.advanceAmountRequested}</td>
                        <td>{new Date(approval.dateOfRequest).toLocaleDateString()}</td>
                        <td>{approval.approvalAuthority}</td>
                        <td>{approval.modeOfAdvanceDisbursement}</td>
                        <td className={getStatusClass(approval.approvalStatus)}>
                          {approval.approvalStatus}
                        </td>
                        <td>
                          {approval.approvalStatus === "Pending" && (
                            <ButtonGroup>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => handleStatusUpdate(approval.advanceReq_id, "Approved")}
                                className="approve-btn"
                              >
                                Approve
                              </Button>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => handleStatusUpdate(approval.advanceReq_id, "Rejected")}
                                className="reject-btn"
                              >
                                Reject
                              </Button>
                            </ButtonGroup>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No advance request approvals found.</p>
          )}
        </Container>
      </div>
  );
};

export default AdvanceRequestApproval;